export default __webpack_public_path__ + "assets/Space_Things.d4b4a056.png";